import { TagsList, TagsListItem } from '@/components/core'
import { BrandTerms, DataSourceType } from '../../types'
import { getSpecificRuleNumber, getTermsForPolarity, parseRules } from '../../utils/index'
import {
  NoRulesText,
  NoTermsText,
  RuleItem,
  RuleNumberSpan,
  RulesPreviewContent,
  SpecificRulesTitle,
  TermsPreviewGrid,
  TermsPreviewItem,
  TermsPreviewSection,
} from './RulesPreview.styles'

export interface RulesPreviewProps {
  specificRulesText: string
  polarityType: string
  termsState: BrandTerms
  activeTab: DataSourceType
  hideTerms?: boolean
}

export function RulesPreview({
  specificRulesText,
  polarityType,
  termsState,
  activeTab,
  hideTerms = false,
}: RulesPreviewProps): JSX.Element {
  const specificRules = parseRules(specificRulesText)
  const { publishersTags, channelsTags, proprietaryTags } = getTermsForPolarity(polarityType, activeTab, termsState)
  const isActiveTabSocial = activeTab === 'social'

  return (
    <div>
      {!hideTerms && (
        <RulesPreviewContent>
          <TermsPreviewSection>
            <h5>Termos - {isActiveTabSocial ? 'Redes Sociais' : 'Imprensa'}</h5>
            <TermsPreviewGrid>
              <TermsPreviewItem>
                <h6>{isActiveTabSocial ? 'Publicadores:' : 'Veículos:'}</h6>
                {(isActiveTabSocial ? publishersTags : channelsTags).length > 0 ?
                  <TagsList
                    maxVisible={10}
                    tags={(isActiveTabSocial ? publishersTags : channelsTags).map(
                      (tag) =>
                        ({
                          id: tag.id,
                          text: tag.text,
                        }) as TagsListItem,
                    )}
                    variant="preview"
                    emptyText="Nenhum definido"
                  />
                : <NoTermsText>Nenhum definido</NoTermsText>}
              </TermsPreviewItem>

              <TermsPreviewItem>
                <h6>Termos Proprietários:</h6>
                {proprietaryTags.length > 0 ?
                  <TagsList
                    maxVisible={10}
                    tags={proprietaryTags.map(
                      (tag) =>
                        ({
                          id: tag.id,
                          text: tag.text,
                        }) as TagsListItem,
                    )}
                    variant="preview"
                    emptyText="Nenhum definido"
                  />
                : <NoTermsText>Nenhum definido</NoTermsText>}
              </TermsPreviewItem>
            </TermsPreviewGrid>
          </TermsPreviewSection>
        </RulesPreviewContent>
      )}

      <div>
        <SpecificRulesTitle>Premissas Específicas</SpecificRulesTitle>
        {specificRules.length > 0 ?
          <div>
            {specificRules.map((rule, index) => (
              <RuleItem key={`specific-${index}`}>
                <RuleNumberSpan>{getSpecificRuleNumber(polarityType, index)}.</RuleNumberSpan>
                <span>{rule}</span>
              </RuleItem>
            ))}
          </div>
        : <NoRulesText>Nenhuma premissa específica definida</NoRulesText>}
      </div>
    </div>
  )
}
